import { FC, useState } from 'react'
import { first } from 'lodash-es'

import usePageClass from '$browser/usePageClass'
import useLoginAttentions from '$actions/useLoginAttentions'

import { LoginAttentionTypes } from '$services/api/types'
import Info from './Info'
import ReplacePassword from './ReplacePassword'
import { format, parseISO } from 'date-fns'
import { Button } from '@trustycars/genie-ui/components'
import { allSet } from './styles.css'
import { serviceName } from '$constants/texts'
import { useMount } from 'ahooks'
import ExtraIcon from '$icons/ExtraIcon'

const pageName = 'LoginAttentions'

export const LoginAttentions: FC = () => {
  usePageClass({ name: pageName })

  const { data, triggerResolvedAction, hasAttentions } = useLoginAttentions()

  const [skippedTypes, setSkippedTypes] = useState<LoginAttentionTypes[]>([])

  const attentions = data.filter(({ type }) => !skippedTypes.includes(type))

  const total = attentions.length
  const formatted = attentions.map((d, index) => ({
    ...d,
    isLast: index + 1 === total
  }))

  const currentAttention = first(formatted)

  const nextAttention = () => {
    if (!currentAttention) return

    if (currentAttention.isLast) {
      triggerResolvedAction()

      return
    }

    setSkippedTypes(old => [...old, currentAttention.type])
  }

  useMount(() => {
    if (!currentAttention || !hasAttentions) {
      triggerResolvedAction()
    }
  })

  if (!currentAttention || !hasAttentions) {
    return (
      <div className={allSet}>
        <div>All set!</div>

        <Button
          styleVariants={{ size: 'small', type: 'text' }}
          onClick={triggerResolvedAction}
        >
          Go back
        </Button>
      </div>
    )
  }

  const { type, required } = currentAttention

  const title = (() => {
    if (type === 'expired_password') return 'Password Expired!'
    if (type === 'password_expiry_is_soon') return 'Password Almost Expire!'
    if (type === 'remind_passkey_registration') return 'Add passkey! (Beta)'

    return 'Action Required!'
  })()
  const description = (() => {
    if (type === 'password_expiry_is_soon') {
      const day = format(parseISO(currentAttention.data.at), 'dd MMM yyyy')

      return `Your password will expire at ${day}. Please update new password before expired.`
    }

    if (type === 'remind_passkey_registration') {
      return `Sign in more securely with passkey. Adding a passkey takes less than a minute.`
    }

    return `Please resolve to continue using ${serviceName}.`
  })()
  const continueBtnText = (() => {
    if (type === 'password_expiry_is_soon') return 'Update Password'

    if (type === 'remind_passkey_registration')
      return (
        <>
          <ExtraIcon name="key-round" />
          Add Passkey
        </>
      )
  })()

  return (
    <Info
      key={type}
      required={required}
      onSkip={nextAttention}
      title={title}
      description={description}
      type={type}
      continueBtnText={continueBtnText}
    >
      {type !== 'remind_passkey_registration' && (
        <ReplacePassword onDone={nextAttention} />
      )}
    </Info>
  )
}

export default LoginAttentions
